export const BASE_API_URL =
  process.env.NODE_ENV === 'dev'
    ? 'http://localhost:5000'
    : 'https://ignite.accenture.com/ignite-apis';